// @flow
import type {
	TRootStore,
} from "../../types";
import LocalStorage from '../../../utils/storage/LocalStorage';


export const getNotificationBar = (state: TRootStore) => {
	const hide_notification = LocalStorage.get('hide_notification_bar');
	const text = state.notifications.notification_bar.text;
	const show = Boolean(state.notifications.notification_bar.show) && !Boolean(hide_notification);

	return {
		text,
		show
	};
};


// WEBPACK FOOTER //
// ./src/modules/selectors/notifications/index.js